import { AxiosResponse } from 'axios'
import getService, { ApiConfig } from 'src/core/services/base'
import apiKey from 'src/core/services/base/apiKey'
import { responseProps } from './model'

const url = '/account/web/permission'

export function getAccountPermission(openUnAuthAlertMemo: () => void, language?: string): Promise<AxiosResponse<responseProps>> {
  return getService<responseProps, ApiConfig<unknown>>(
    {
      config: {
        url,
        method: 'get',
        headers: {
          'Accept-Language': language,
        },
      },
      name: apiKey.getAccountPermission,
    },
    openUnAuthAlertMemo,
  )
}
